import { authHeader, handleHttpResponse } from '_helpers';
import {SERVER_URL} from 'config';

function update(organizationId, data) {
    return fetch(`${SERVER_URL}/api/organizations/${organizationId}/salesforce/configuration`,
        {
            method: 'PUT',
            headers: authHeader(),
            body: JSON.stringify(data)
        })
        .then(handleHttpResponse);
}

export const salesforceOrgConfigService = {
    update
};
